import React from 'react';
import jpSetAction from '../../actions/jpSetAction';

class EmailModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            txtValue1: "",
           
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    handleChange(e) {
        let value = e.target.value;
        this.setState({ txtValue1: value });
    }
    handleSubmit(e) {
       jpSetAction.addEmail(this.state.txtValue1);
       this.props.shouldModalClose(false);
    }
    modalClose() {
        this.props.shouldModalClose(false);
    }
    renderBody() {
        let body = "";
        body = (
            <div> 
                <form>
                    <label>Email</label>
                    <input className="form-control" type="email" onChange={this.handleChange} value={this.state.txtValue1} />
                </form>
            </div>
        );

        return (body);
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        let content;

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >Add Email</h4>
                    </div>

                    <div className="modal-body" >
                        {this.renderBody()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn btn-warning"}
                            onClick={this.handleSubmit}>
                            Add
                        </button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default EmailModal;


// WEBPACK FOOTER //
// ./app/setComponents/jpSetComponents/emailModal.js